/** What a plate's action crystals show: `slots` crystals, the first `ready` lit, the last `locked` barred, and the next one filling as `remaining` counts down. */
export interface PipState { slots: number; ready: number; locked: number; remaining: number }
interface Seen { ready: number; remaining: number; period: number }
const seen = new WeakMap<HTMLElement, Seen>();

/** A row of action crystals for under a plate's health channel, cut like the medallions' crystals. */
export function buildPips() {
  const row = document.createElement('span'); row.className = 'plate-pips'; row.hidden = true;
  return row;
}
const pip = () => { const crystal = document.createElement('span'); crystal.append(document.createElement('i')); return crystal; };

/** Reads only the snapshot: lit crystals are ready actions, and the next crystal fills with light through the recovery the server is counting down. */
export function updatePips(row: HTMLElement, { slots, ready, locked, remaining }: PipState) {
  while (row.children.length < slots) row.append(pip());
  while (row.children.length > slots) row.lastElementChild!.remove();
  // The recovery period is taken from the countdown itself (it restarts at a full period), so dying, Dazed and monster rounds need no server timings here.
  const last = seen.get(row), wrapped = !last || remaining > last.remaining + .05;
  const period = Math.max(wrapped ? remaining : last.period, remaining, .01);
  seen.set(row, { ready, remaining, period });
  const crystals = [...row.children] as HTMLElement[];
  crystals.forEach((crystal, index) => {
    const state = index < ready ? 'on' : index >= slots - locked ? 'locked' : 'empty';
    if (crystal.dataset.state !== state) crystal.dataset.state = state;
    crystal.style.setProperty('--fill', state === 'empty' && index === ready ? (1 - remaining / period).toFixed(3) : '0');
  });
  // A crystal that has just come back flashes once.
  if (last && ready > last.ready) for (const crystal of crystals.slice(last.ready, ready)) { crystal.classList.remove('lit'); void crystal.offsetWidth; crystal.classList.add('lit'); }
}
